import Link from 'next/link';
import styled from 'styled-components';
import i18n from 'src/utils/translate';
import { logout } from 'src/modules/shared/auth/actions';
import { useDispatch } from 'react-redux';
import Button from '../buttons/button';

type Props = {
  className?: string;
}
export default function MoreList({className}: Props) {
  const dispatch = useDispatch();

  return (
    <ul className={className}>
      <li>
        <Link href="/profile/edit">
          <a>
            <Icon className="icon-profile-1" />
            {i18n.t('Update Profile')}
          </a>
        </Link>
      </li>
      <li>
        <a href="/people-near-me">
          <Icon className="icon-people" />
          {i18n.t('Find people near me')}
        </a>
      </li>
      <li>
        <Link href="/your-needs">
          <a>
            <Icon className="icon-newsfeed" />
            {i18n.t('Your needs')}
          </a>
        </Link>
      </li>
      <li>
        <a href="/settings">
          <Icon className="icon-settings" />
          {i18n.t('Settings')}
        </a>
      </li>
      <li>
        <Link href="/email-notifications">
          <a>
            <Icon className="icon-mail-1" />
            {i18n.t('Email notifications')}
          </a>
        </Link>
      </li>
      <li>
        <Button type="none" onClick={() => window.HelpscoutBeacon.triggerHelpScoutBeacon('USER_SUPPORT')}>
          <Icon className="icon-help" />
          {i18n.t('Help')}
        </Button>
      </li>
      <li>
        <Button type="none" onClick={() => dispatch(logout())}>
          <Icon className="icon-logout" />
          {i18n.t('Log out')}
        </Button>
      </li>
    </ul>
  );
}

const Icon = styled.span`
  margin-right: 15px;
  font-size: 17px;
`;
